import { render, staticRenderFns } from "./OrdersMainPage.vue?vue&type=template&id=53e05d16&scoped=true&"
import script from "./OrdersMainPage.vue?vue&type=script&lang=js&"
export * from "./OrdersMainPage.vue?vue&type=script&lang=js&"
import style0 from "./OrdersMainPage.vue?vue&type=style&index=0&id=53e05d16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e05d16",
  null
  
)

export default component.exports